// extracted by mini-css-extract-plugin
module.exports = {"listWrap":"listWrap--2Nsa8","item":"item--3-FL6","imageWrap":"imageWrap--2iSdE","mask":"mask--sZ7ke","describe":"describe--JboCy","title":"title--3XaGH"};